/**
 *
 * This file was automatically generated using build-models npm script and should not be edited
 *
 **/
export const CreateDocumentInputJsonApiModel = {
  id: "",
  document: {
    jsonApi: "hasOne",
    type: "documents",
  },
};
